export default {
	computed: {
		syncRules() {
			if (this.gestiosField) {
				if (this.gestiosField.Parser) {
					const parse = this.gestiosField.Parser.split('|') || [this.gestiosField.Parser];

					if (parse) {
						const fRules = {};

						for (let i = 0; i < parse.length; i += 1) {
							const item = parse[i];
							const parsedRule = item.replace(/ *\[[^)]*\] */g, '');
							const parsedValue = item.match(/\[([^)]+)\]/) ? item.match(/\[([^)]+)\]/)[1] : '';

							fRules[parsedRule] = parsedValue || '';
						}

						return fRules;
					}
				}
			}
			return {};
		},
		fieldRules() {
			const rules = [];

			if (this.rules) return this.rules;

			if (this.gestiosField) {
				if (this.required === true || (this.gestiosField.Required && this.required === null)) {
					if (this.attrs.type === 'relation' || this.attrs.type === 'select' || this.attrs.type === 'user') {
						rules.push('relationRequired');
					} else {
						rules.push('required');
					}
				}

				switch (this.attrs.type) {
					case 'text':
						if (this.gestiosField) {
							const maxlength = parseInt(this.gestiosField.Maxlength, 10);
							if (maxlength > 0) rules.push(`max:${maxlength}`);
						}
						break;

					case 'integer':
						Object.keys(this.gestiosRules).forEach((rule) => {
							const value = this.gestiosRules[rule];

							if (rule === 'is_natural') {
								rules.push('min_value:0');
							} else if (rule === 'is_natural_no_zero') {
								rules.push('min_value:1');
							} else if (rule === 'greater_than_equal_to') {
								rules.push(`min_value:${value}`);
							} else if (rule === 'less_than_equal_to') {
								rules.push(`max_value:${value}`);
							}
						});

						break;

					case 'double':
						Object.keys(this.gestiosRules).forEach((rule) => {
							const value = this.gestiosRules[rule];

							if (rule === 'is_natural') {
								rules.push('min_value:0');
							} else if (rule === 'is_natural_no_zero') {
								rules.push('min_value:1');
							} else if (rule === 'greater_than_equal_to') {
								rules.push(`min_value:${value}`);
							} else if (rule === 'less_than_equal_to') {
								rules.push(`max_value:${value}`);
							}
						});

						break;

					case 'select':
						break;

					default:
				}
			} else if (this.required) {
				if (this.attrs.type === 'relation' || this.attrs.type === 'select' || this.attrs.type === 'user') {
					rules.push('relationRequired');
				} else {
					rules.push('required');
				}
			}

			return rules.join('|');
		}
	}
};
